import { colors } from '@/@mui/tokens/colors';

export const palette = {
  background: {
    default: colors.neutral[100],
    paper: colors.neutral[0],
  },
  primary: {
    ...colors.primary,
    light: colors.primary[100],
    main: colors.primary[400],
    dark: colors.primary[900],
  },
  secondary: {
    light: colors.secondary[100],
    main: colors.secondary[200],
    dark: colors.secondary[300],
  },
  error: {
    ...colors.error,
    light: colors.error[100],
    main: colors.error[500],
    dark: colors.error[900],
  },
  success: {
    ...colors.success,
    light: colors.success[100],
    main: colors.success[500],
    dark: colors.success[900],
  },
  warning: {
    ...colors.warning,
    light: colors.warning[100],
    main: colors.warning[400],
    dark: colors.warning[900],
  },
  info: {
    ...colors.info,
    light: colors.info[100],
    main: colors.info[400],
    dark: colors.info[900],
  },
  text: {
    primary: colors.neutral[900],
    secondary: colors.neutral[700],
    disabled: colors.neutral[300],
  },
  status: { ...colors.status },
  neutral: {
    ...colors.neutral,
    lighter: colors.neutral[100],
    light: colors.neutral[300],
    main: colors.neutral[500],
    dark: colors.neutral[700],
    darker: colors.neutral[900],
  },
};
